module.exports = __webpack_public_path__ + "img/special_dark.2b226718.png";